import { useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { motion as Motion } from "framer-motion";
import cls from "./Underage.module.scss";

/* Mobile images (same as AgeGate) */
import MrM from "@/assets/UI/under/MrM.webp";
import MrsM from "@/assets/UI/under/MrsM.webp";
import PLM from "@/assets/UI/under/PLM.webp";
import PRM from "@/assets/UI/under/PRM.webp";

/* Desktop images (same as AgeGate) */
import MrD from "@/assets/UI/under/MrD.webp";
import MrsD from "@/assets/UI/under/MrsD.webp";
import PLD from "@/assets/UI/under/PLD.webp";
import PRD from "@/assets/UI/under/PRD.webp";

/* ===== Animations (same feel as AgeGate) ===== */
const floatSlow = {
  hidden: { opacity: 0.5 },
  show: {
    opacity: [0.5, 0.65, 0.5],
    scale: [1, 1.06, 1],
    transition: {
      duration: 10,
      ease: "easeInOut",
      repeat: Infinity,
    },
  },
};

const floatSlowAlt = {
  hidden: { opacity: 0.5 },
  show: {
    opacity: [1, 0.62, 1],
    scale: [1.06, 1, 1.06],
    x: [0, -6, 0],
    transition: {
      duration: 12,
      ease: "easeInOut",
      repeat: Infinity,
    },
  },
};

export default function Underage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear any age-ok flag on arrival
    try {
      localStorage.removeItem("cm_age_ok");
    } catch {
      // Intentionally ignored: localStorage cleanup failure should not block the UI.
    }
  }, []);

  const handleBack = useCallback(() => {
    navigate("/age");
  }, [navigate]);

  const handleLeave = useCallback(() => {
    window.location.href = "https://www.google.com";
  }, []);

  return (
    <main className={cls.page}>
      <div className={cls.pageInner}>
        <section className={cls.heroStage} aria-label="Underage notice">
          {/* ===== MOBILE ===== */}
          <div className={cls.mobileOnly} aria-hidden="true">
            <Motion.img
              className={`${cls.heroImg} ${cls.z0}`}
              src={MrM}
              alt=""
              variants={floatSlow}
              initial="hidden"
              animate="show"
              draggable="false"
            />
            <Motion.img
              className={`${cls.heroImg} ${cls.z1}`}
              src={MrsM}
              alt=""
              variants={floatSlowAlt}
              initial="hidden"
              animate="show"
              draggable="false"
            />

            <button
              type="button"
              onClick={handleLeave}
              className={`${cls.heroHalfBtn} ${cls.leftHalf}`}
              aria-label="Leave this website."
            >
              <img
                src={PLM}
                alt=""
                className={`${cls.heroHalfImg} ${cls.z3}`}
                draggable="false"
              />
            </button>

            <button
              type="button"
              onClick={handleBack}
              className={`${cls.heroHalfBtn} ${cls.rightHalf}`}
              aria-label="I clicked No by mistake. Go back. "
            >
              <img
                src={PRM}
                alt=""
                className={`${cls.heroHalfImg} ${cls.z3}`}
                draggable="false"
              />
            </button>
          </div>

          {/* ===== DESKTOP ===== */}
          <div className={cls.desktopOnly} aria-hidden="true">
            <Motion.img
              className={`${cls.heroImg} ${cls.z0}`}
              src={MrD}
              alt=""
              variants={floatSlow}
              initial="hidden"
              animate="show"
              draggable="false"
            />
            <Motion.img
              className={`${cls.heroImg} ${cls.z1}`}
              src={MrsD}
              alt=""
              variants={floatSlowAlt}
              initial="hidden"
              animate="show"
              draggable="false"
            />

            <button
              type="button"
              onClick={handleLeave}
              className={`${cls.heroHalfBtn} ${cls.leftHalf}`}
              aria-label="Leave this website."
            >
              <img
                src={PLD}
                alt=""
                className={`${cls.heroHalfImg} ${cls.z3}`}
                draggable="false"
              />
            </button>

            <button
              type="button"
              onClick={handleBack}
              className={`${cls.heroHalfBtn} ${cls.rightHalf}`}
              aria-label="I clicked No by mistake. Go back. "
            >
              <img
                src={PRD}
                alt=""
                className={`${cls.heroHalfImg} ${cls.z3}`}
                draggable="false"
              />
            </button>
          </div>
        </section>
      </div>
    </main>
  );
}
